import { db, auth } from "../../firebase";
import { doc, setDoc, increment, serverTimestamp } from "firebase/firestore";

export const logSiteVisit = async () => {
  const user = auth.currentUser;
  if (!user) return; // ←★ 沒登入直接 return

  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  const ref = doc(db, "siteMetrics", today);
  try {
    await setDoc(ref, {
      visits: increment(1),
      lastVisit: serverTimestamp(),
    }, { merge: true });
  } catch (e) {
    // 這樣即使萬一出錯也不會造成 uncaught
    if (e.code === "permission-denied") {
      // 可以 silent 或 log
      // console.warn("Firestore 權限不足，已忽略 logSiteVisit");
    } else {
      console.error(e);
    }
  }
};
